import React, { useEffect, useState } from "react";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, TextField, Typography } from "@mui/material";

function UPSE4DetalleProducto({
  open,
  onClose,
  onSubmit,
  producto,
  categorias,
  mostrarBeneficiarios
}) {
  const [cantidadEjecutada, setCantidadEjecutada] = useState(0);
  const [observaciones, setObservaciones] = useState("");
  const [cantidadesPorCategoria, setCantidadesPorCategoria] = useState({});
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setCantidadEjecutada(producto?.detalle?.cantidadEjecutada || 0);
    setObservaciones(producto?.detalle?.observaciones || "");

    const valoresIniciales = {};
    (producto?.detalle?.beneficiarios || []).forEach((b) => {
      valoresIniciales[b.idCategoriaBeneficiario] = b.cantidad;
    });
    setCantidadesPorCategoria(valoresIniciales);
  }, [producto]);

  const cancelar = () => {
    setMensajeError("");
    onClose();
  };

  const handleCategoriaChange = (idCategoria, valor) => {
    setCantidadesPorCategoria((prev) => ({ ...prev, [idCategoria]: valor }));
  };

  const registrar = () => {
    if (cantidadEjecutada === "" || cantidadEjecutada < 0) {
      setMensajeError("Debe ingresar la cantidad ejecutada");
      return;
    }

    const beneficiarios = mostrarBeneficiarios
      ? (categorias || [])
        .filter((c) => Number(cantidadesPorCategoria[c.Id]) > 0)
        .map((c) => ({
          idCategoriaBeneficiario: c.Id,
          cantidad: Number(cantidadesPorCategoria[c.Id])
        }))
      : [];

    const payload = {
      cantidadEjecutada: Number(cantidadEjecutada),
      observaciones,
      beneficiarios
    };

    setMensajeError("");
    onSubmit(payload);
    onClose();
  };

  const grupos = mostrarBeneficiarios
    ? (categorias || []).reduce((acc, cat) => {
      if (!acc[cat.Grupo]) acc[cat.Grupo] = [];
      acc[cat.Grupo].push(cat);
      return acc;
    }, {})
    : {};

  return (
    <Dialog open={open} onClose={cancelar} maxWidth="md" fullWidth>
      <DialogTitle>
        {producto?.cultivar
          ? `${producto?.subproducto} · ${producto?.tipoCultivo} · ${producto?.cultivar}`
          : producto?.producto}
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Cantidad ejecutada"
              name="cantidadEjecutada"
              type="number"
              value={cantidadEjecutada}
              onChange={(e) => setCantidadEjecutada(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center' }}>
            <strong>Meta planificada del mes: {producto?.metaMes ?? '-'}</strong>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Observaciones"
              name="observaciones"
              type="text"
              multiline
              rows={2}
              value={observaciones}
              onChange={(e) => setObservaciones(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {mostrarBeneficiarios && (
            <Grid item xs={12}>
              <Divider sx={{ marginY: 2 }} />
              <Typography variant="subtitle1" fontWeight="bold">Beneficiarios</Typography>
            </Grid>
          )}

          {mostrarBeneficiarios && Object.entries(grupos).map(([grupo, items]) => (
            <React.Fragment key={grupo}>
              <Grid item xs={12}>
                <Typography variant="body2" fontWeight="bold">{grupo}</Typography>
              </Grid>
              {items.map((cat) => (
                <Grid item xs={6} sm={3} key={cat.Id}>
                  <TextField
                    fullWidth
                    label={cat.Nombre}
                    type="number"
                    value={cantidadesPorCategoria[cat.Id] ?? 0}
                    onChange={(e) => handleCategoriaChange(cat.Id, e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              ))}
            </React.Fragment>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Typography color={'error'} marginRight={2}>{mensajeError}</Typography>
        <Button onClick={cancelar}>Cancelar</Button>
        <Button onClick={registrar} variant="contained" color="primary">Registrar</Button>
      </DialogActions>
    </Dialog>
  );

}

export { UPSE4DetalleProducto };
